// extracted by mini-css-extract-plugin
export default {"moviesGrid":"PelisGrid_moviesGrid__0aDWD"};